import React from 'react';
import PropTypes from 'prop-types';

import './JudgeBadge.scss';

// The latest moments-judge outcome as a compact chip; renders nothing until a
// judge has run.
const JudgeBadge = ({ verdict, score }) => {
  if (!verdict) return null;
  return (
    <span className={`msa-judge-badge is-${verdict}`} title={`Judge: ${verdict}${score != null ? ` · ${score}/10` : ''}`}>
      {verdict === 'pass' ? 'Judge ✓' : verdict === 'concern' ? 'Judge — concern' : 'Judge ✗'}
      {score != null ? ` ${Number(score).toFixed(1)}` : ''}
    </span>
  );
};

JudgeBadge.propTypes = {
  verdict: PropTypes.string,
  score: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default JudgeBadge;
